/***
 * Created on 2024/4/15
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
import {useTranslation} from "react-i18next";
import {getLocalUser} from "../../../../../../service/user";
import {QnapAuthPanelRow} from "./qnap_auth_panel_row";


export const QnapAuthMethodDisplayName = {
    totp: '@TOTP@',
    qrcode: '@QR Code@',
    'login-approval': '@Login Approval@',
    'online-verification-code': '@Online Verification Code@'
}

function QnapAuthPanel(props) {
    const {t} = useTranslation();
    const currentUser = getLocalUser();

    return (
        <section className="two-step--setting">
            <header>{t('@QNAP Authenticator@')}</header>
            <div className="comp-content-wrapper">
                <QnapAuthPanelRow method={'totp'} label={t(QnapAuthMethodDisplayName['totp'])} qnap_auth={currentUser?.secure?.qnap_auth} google_auth={currentUser?.secure?.google_auth}/>
                <QnapAuthPanelRow method={'qrcode'} label={t(QnapAuthMethodDisplayName['qrcode'])} qnap_auth={currentUser?.secure?.qnap_auth}/>
                <QnapAuthPanelRow method={'login-approval'} label={t(QnapAuthMethodDisplayName['login-approval'])} qnap_auth={currentUser?.secure?.qnap_auth}/>
                <QnapAuthPanelRow method={'online-verification-code'} label={t(QnapAuthMethodDisplayName['online-verification-code'])} qnap_auth={currentUser?.secure?.qnap_auth}/>
            </div>
        </section>
    );
}

export default QnapAuthPanel;